export default __webpack_public_path__ + "static/media/BS.141b246a.svg";